import type { Money } from '@klear/money'
import { moneyChartValue } from '@klear/ui/components/chart-series'
import { useMemo } from 'react'
import { calculateKlearAccountDailyBalance } from '@klear/treasury/daily-balance'
import type { KlearAccountTransactionRead } from '@klear/treasury/klear-account-transaction-read'
import { DEFAULT_FINANCIAL_HISTORY_WINDOW_RANGE } from '@klear/constants'

export interface DailyBalancePoint {
  date: string
  balance: number
}

export function useDailyBalancesFromTransactions(
  transactions: KlearAccountTransactionRead[] | undefined,
  currentBalance: Money | undefined,
  historyWindowDays: number = DEFAULT_FINANCIAL_HISTORY_WINDOW_RANGE
): DailyBalancePoint[] {
  return useMemo(() => {
    if (!transactions || currentBalance === undefined) {
      return []
    }

    return calculateKlearAccountDailyBalance(transactions, currentBalance, historyWindowDays).map(
      ({ date, balance }) => ({ date, balance: moneyChartValue(balance) })
    )
  }, [transactions, currentBalance, historyWindowDays])
}
